"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Rectangle_1 = __importDefault(require("../../../loaders/Rectangle/Rectangle"));
require("./collectionCredentialsBlockLoader.scss");
function CollectionCredentialsBlockLoader(props) {
    return !props.isMobile ? (react_1.default.createElement("div", { id: "collection-credentials-block-loader-web", className: "flex-row credentials" },
        react_1.default.createElement("div", { style: {
                width: "275px",
                height: "240px",
                borderRadius: "8px",
                marginRight: "45px",
                marginTop: "20px",
            } },
            react_1.default.createElement(Rectangle_1.default, { width: 275, height: 240, radius: 8 })),
        react_1.default.createElement("div", { style: {
                width: "275px",
                height: "240px",
                borderRadius: "8px",
                marginRight: "45px",
                marginTop: "20px",
            } },
            react_1.default.createElement(Rectangle_1.default, { width: 275, height: 240, radius: 8 })))) : (react_1.default.createElement("div", { id: "collection-credentials-block-loader-mobile", className: "flex-column" },
        react_1.default.createElement("div", { style: {
                width: "100%",
                height: "323px",
                borderRadius: "8px",
                marginRight: "0px",
                marginTop: "20px",
                overflow: "hidden",
            } },
            react_1.default.createElement(Rectangle_1.default, { width: 200, height: 323, radius: 8 })),
        react_1.default.createElement("div", { style: {
                width: "100%",
                height: "323px",
                borderRadius: "8px",
                marginRight: "0px",
                marginTop: "20px",
                overflow: "hidden",
            } },
            react_1.default.createElement(Rectangle_1.default, { width: 200, height: 323, radius: 8 }))));
}
exports.default = CollectionCredentialsBlockLoader;
